'use client'
import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import DocViewer, {DocViewerRenderers} from "@cyntler/react-doc-viewer";
import ReactToPrint from "react-to-print";
import {LabRecordsPrintView} from "../../diagnostics/lab/LabRecordsPrintView";
import {PatientPreconditionsView} from "../../customer/category/PatientPreconditionsView";
import {IpdPrescriptionWritingView} from "../IpdPrescriptionWritingView";
import {CaseHeaderView} from "./CaseHeaderView";
import upload from "../../../pages/api/s3/upload";

export const CaseFile = (props: { caseId: any, doctors: Array<any>, stateTracker: any, uploads:Array<any> }) => {

    const [records, setRecords] = useState([])
    const [caseDetails, setCaseDetails] = useState<any>()
    const [caseDetailsJson, setCaseDetailsJson] = useState<any>({})
    const [auditEntries, setAuditEntries] = useState<Array<any>>([])
    const [events, setEvents] = useState([])
    const [assignedDrQr, setAssignedDrQr] = useState<any>()
    const [dischargeDate, setDischargeDate] = useState<string>()
    let componentRef = useRef(null);

    function fetchEvents(uhid) {
        axios.get('/api/backend/customers/fetch/' + uhid + '/events')
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setEvents(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    function fetchAuditTrail(caseId, entityQr) {
        axios.get('/api/backend/ipd/case/audit/fetch/all/' + entityQr + "/" + caseId)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setAuditEntries(resp.data)
                const dischargeEntry = resp.data.filter((entry) => entry.type == "DISCHARGE_SUMMARY")
                if (dischargeEntry && dischargeEntry.length > 0) {
                    setDischargeDate(dischargeEntry[0].updatedAt)
                }
                resp.data.map(entry => {
                    if (entry.type == "SERVICE") {
                        axios.get('/api/backend/customer/records/fetch/all/' + entry.id + "?isIpd=true")
                            .then(resp => {
                                console.log(JSON.stringify(resp.data))
                                resp.data.records.map(ar => {
                                    setRecords(recs => {
                                        var newRecs = [...recs]
                                        if (recs.filter(r => r.medicalRecordId == ar.id).length == 0) {
                                            newRecs.push({...ar, "medicalRecordId": ar.id})
                                        }
                                        return newRecs
                                    })
                                })
                            })
                            .catch(err => {
                                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                            })
                    }

                })
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    function fetchCase() {
        axios.get('/api/backend/ipd/case/fetch/' + props.caseId)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setCaseDetails(resp.data)
                if (props.doctors && props.doctors.filter(dr => dr.id == resp.data.assignedDrId).length > 0) {
                    setAssignedDrQr(props.doctors.filter(dr => dr.id == resp.data.assignedDrId)[0]["qrCode"])
                }
                if (resp.data.caseDetails) {
                    setCaseDetailsJson(JSON.parse(resp.data.caseDetails))
                }
                fetchAuditTrail(resp.data.id, resp.data.entityQr)
                fetchEvents(resp.data.uhid)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {
        if (props.caseId) {
            fetchCase();
        }
    }, [props.caseId, props.stateTracker])


    function getDischargeSummaryView() {
        return <div>
            {/* component to be printed */}

            <hr/>
            <div className="d-flex justify-content-end">
                <div className="text-warning align-self-center">* Please scroll & print the uploaded documents
                    seperately
                </div>
                &nbsp;&nbsp;
                <div className="align-self-center"><ReactToPrint
                    trigger={() => <button className="btn btn-outline-primary"
                    >&#128424; Case Summary</button>}
                    content={() => componentRef.current}
                /></div>
            </div>
            <hr/>
            <div ref={componentRef} className="px-5">
                <div className="printElements">
                    <div
                        className="text-secondary text-center text-decoration-underline font-weight-bold fs-5 pb-3">Discharge
                        Summary{caseDetails && caseDetails.patientStatus && caseDetails.patientStatus != "DISCHARGE" ? " - " + caseDetails.patientStatus : ""}
                    </div>
                    <CaseHeaderView caseDetails={caseDetails} dischargeDate={dischargeDate}/>
                    <div className="d-flex">
                        <table className="fs-7">
                            {caseDetails && caseDetails.purpose && <>
                                <tr>
                                    <td className="py-1">
                                        <div>
                                            <div className="fw-bold text-decoration-underline py-3 fs-6">Purpose</div>
                                            <div className="pl-md-5" style={{whiteSpace: "pre-line"}}>
                                                {caseDetails && caseDetails.purpose}
                                            </div>
                                        </div>

                                    </td>
                                </tr>
                            </>}

                            <tr>
                                <td className="py-1 align-top">
                                    <div>
                                        <div className="fw-bold text-decoration-underline py-1 fs-6">Medical Details
                                        </div>
                                        <div className="pl-md-5">
                                            <div className="row">
                                                {caseDetailsJson["cc"] && <div className="col col-6">
                                                    <div className="d-flex my-1">
                                                        <span className=" fw-bold">Chief Complaints :&nbsp;</span>
                                                        <div
                                                            style={{whiteSpace: "pre-line"}}>{caseDetailsJson["cc"]}</div>
                                                    </div>
                                                </div>}
                                                {caseDetailsJson["hpi"] && <div className="col col-6">
                                                    <div className="d-flex my-1">
                                                        <span
                                                            className="fw-bold">History of Present Illness :&nbsp;</span>
                                                        <div
                                                            style={{whiteSpace: "pre-line"}}>{caseDetailsJson["hpi"]}</div>
                                                    </div>
                                                </div>}
                                                {caseDetailsJson["personal_history"] && <div className="col col-6">
                                                    <div className="d-flex my-1">
                                                        <span className=" fw-bold">Personal History :&nbsp;</span>
                                                        <div
                                                            style={{whiteSpace: "pre-line"}}>{caseDetailsJson["personal_history"]}</div>
                                                    </div>
                                                </div>}
                                                {caseDetailsJson["birth_history"] && <div className="col col-6">
                                                    <div className="d-flex my-1">
                                                        <span className=" fw-bold">Birth/Family History :&nbsp;</span>
                                                        <div
                                                            style={{whiteSpace: "pre-line"}}>{caseDetailsJson["birth_history"]}</div>
                                                    </div>
                                                </div>}
                                                {caseDetailsJson["drug_allergy"] && <div className="col col-6">
                                                    <div className="d-flex my-1">
                                                        <span className=" fw-bold">Drug Allergy :&nbsp;</span>
                                                        <div
                                                            style={{whiteSpace: "pre-line"}}>{caseDetailsJson["drug_allergy"]}</div>
                                                    </div>
                                                </div>}

                                                {caseDetailsJson["treatment_history"] && <div className="col col-6">
                                                    <div className="d-flex my-1">
                                                        <span className=" fw-bold">Treatment History :&nbsp;</span>
                                                        <div
                                                            style={{whiteSpace: "pre-line"}}>{caseDetailsJson["treatment_history"]}</div>
                                                    </div>
                                                </div>}
                                                {events && events.length > 0 && <div className="col col-6 ">
                                                    <PatientPreconditionsView
                                                        preconditions={events} updatePreconditions={null}
                                                        isEditable={false} entityQr={null} category={null}/>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>

                            {caseDetails && caseDetails.diagnosis &&
                                <>
                                    <tr>
                                        <td className="py-1 align-top">
                                            <div>
                                                <div className="fw-bold text-decoration-underline py-1 fs-6">Diagnosis
                                                </div>
                                                <div className="pl-md-5" style={{whiteSpace: "pre-line"}}>
                                                    {caseDetails && caseDetails.diagnosis}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </>}
                            {records && records.length > 0 && <>
                                <tr>
                                    <td className="py-1 align-top">
                                        <div>
                                            <div className="fw-bold text-decoration-underline py-1 fs-6">Investigations
                                                /
                                                Services
                                            </div>
                                            <div className="pl-md-5">
                                                <table>

                                                    {records.map((entry) => {
                                                        return <tr key={entry.recordType}>
                                                            <td className="text-nowrap align-top">{entry && entry.recordType}</td>
                                                            <td className="pl-4 align-top">{entry.description && entry.description != "null" &&
                                                                <div
                                                                    dangerouslySetInnerHTML={{__html: entry.description}}/>}</td>
                                                        </tr>
                                                    })}
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </>}
                            <tr>
                                <td className="py-1 align-top">
                                    <div>
                                        <div className="fw-bold text-decoration-underline py-1 fs-6">Procedures /
                                            Surgeries
                                        </div>
                                        <div className="pl-md-5">
                                            <table>

                                                {auditEntries.filter(e => e.type == "PROCEDURE").map((entry) => {
                                                    return <tr key={entry.procedureName}>
                                                        <td className="text-nowrap align-top">{entry.procedureName}</td>
                                                        <td className="pl-4 align-top">{entry.procedureDetails && entry.description != "null" &&
                                                            <div
                                                                dangerouslySetInnerHTML={{__html: entry.procedureDetails}}/>}</td>
                                                    </tr>
                                                })}
                                            </table>
                                        </div>
                                    </div>
                                </td>

                            </tr>
                            <tr>
                                <td className="py-1 align-top">
                                    <div>
                                        <div className="fw-bold text-decoration-underline py-1 fs-6">Treatment
                                            Details
                                        </div>
                                        <div className="pl-md-5">
                                            <table>

                                                {auditEntries.filter(e => e.type == "VISIT").map((entry) => {
                                                    return <tr key={entry.procedureName}>
                                                        <td className="text-nowrap align-top">{entry.assignedDr ? entry.assignedDr + " (" + entry.createdAt + ")" : entry.createdAt}</td>
                                                        <td className="pl-4 align-top">{entry.notes && entry.notes != "null" &&
                                                            <div dangerouslySetInnerHTML={{__html: entry.notes}}/>}</td>
                                                    </tr>
                                                })}
                                            </table>
                                        </div>
                                    </div>
                                </td>

                            </tr>
                            {auditEntries.map((entry) => {
                                return <>
                                    {entry.type == "DISCHARGE_SUMMARY" && <>
                                        <tr>
                                            <td className="py-1 align-top">
                                                <div>
                                                    <div
                                                        className="fw-bold text-decoration-underline py-1 fs-6">Discharge
                                                        Remarks
                                                    </div>
                                                    <div className="pl-md-5">
                                                        <div dangerouslySetInnerHTML={{__html: entry.notes}}/>
                                                        {entry.presId && <div className="multi-pager">
                                                            <IpdPrescriptionWritingView entityQr={caseDetails.entityQr}
                                                                                        isEditable={false}
                                                                                        qrCode={assignedDrQr}
                                                                                        id={entry.presId}/>
                                                        </div>}
                                                        {entry.extraDetails && JSON.parse(entry.extraDetails).follow_up_date && <div className="my-1">
                                                            <span className="fw-bold">Follow-up Date :</span> {new Date(JSON.parse(entry.extraDetails).follow_up_date).toLocaleDateString("en-GB")}
                                                        </div>}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="py-2 align-top">
                                                <div className="d-flex justify-content-between">
                                                    <div>Patient Signature:</div>
                                                    <div>RMO Signature:</div>
                                                </div>
                                                <div className="d-flex justify-content-between mt-5">
                                                    <div>Consultants:<br/><br/><br/></div>
                                                    <div className="mr-4">Attendants:<br/><br/><br/></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </>}
                                </>
                            })}
                        </table>
                    </div>
                </div>
                <div>
                    {auditEntries.filter(e => e.type == "SERVICE").map((entry) => {
                        return <>
                            {entry &&
                                <LabRecordsPrintView uhid={caseDetails && caseDetails.uhid}
                                                     entityQr={caseDetails && caseDetails.entityQr} printHeader={false}
                                                     visitId={entry.id} stateTracker={null} referringDr={caseDetails && caseDetails.assignedDr}/>
                            }
                        </>
                    })}
                    {records.map((entry) => {
                        return <>
                            {entry && entry.data && JSON.parse(entry.data).key && !isPdf(JSON.parse(entry.data).key) &&
                                <div className="printElements border">
                                    <div className="font-weight-bold text-center pt-2">Record - {entry.recordType}</div>
                                    <img alt="case-file-view-icon"
                                         src={"/api/s3/download/?file=" + JSON.parse(entry.data).key} width="100%"/>
                                </div>
                            }
                        </>
                    })}
                </div>
                <style jsx>{`@page {
                          margin: 40px 0 40px 0 !important;
                        }`}</style>
            </div>
            <hr/>
            <div className="d-flex justify-content-end">
                <div className="text-warning align-self-center">* Please scroll & print the uploaded documents
                    seperately
                </div>
                &nbsp;&nbsp;
                <div className="align-self-center"><ReactToPrint
                    trigger={() => <button className="btn btn-outline-primary"
                    >&#128424; Case Summary</button>}
                    content={() => componentRef.current}
                /></div>
            </div>
            <hr/>
            <div>
                {records.map((entry) => {
                    return <>
                        {entry && entry.data && JSON.parse(entry.data).key && isPdf(JSON.parse(entry.data).key) &&
                            <div className="printElements">
                                <div className="font-weight-bold text-center pt-2">Record - {entry.recordType}</div>
                                <iframe src={"/api/s3/download/?file=" + JSON.parse(entry.data).key} width="100%"
                                        height="800px"/>
                            </div>
                        }
                    </>
                })}
            </div>

            <div>
                {props.uploads.map((entry) => {
                    return <>
                    {isPdf(entry.key) && <div className="printElements">
                                <div className="font-weight-bold text-center pt-4">Uploaded - {entry.name}</div>
                                <iframe src={"/api/s3/download/?file=" + entry.key} width="100%"
                                        height="800px"/>
                            </div>}
                    {!isPdf(entry.key) && <div className="printElements border">
                            <div className="font-weight-bold text-center pt-4">Uploaded - {entry.name}</div>
                            <img alt="case-file-view-icon"
                                 src={"/api/s3/download/?file=" + entry.key} width="100%"/>
                        </div>}
                    </>
                })}
            </div>
        </div>;
    }

    return (
        <>
            {getDischargeSummaryView()}
        </>
    );

    function isPdf(fileName) {
        const fileArr = fileName.split(".")
        return fileArr[fileArr.length - 1] == "pdf";
    }

}